<div class="documents-container">
  <div class="page-header">
    <h2>RAG Document Management</h2>
    <div class="header-actions">
      <div class="use-code-input">
        <label>Use Code:</label>
        <input type="text" [(ngModel)]="useCode" placeholder="Optional" (change)="loadFiles()">
      </div>
      <button class="btn btn-primary" (click)="openNewDirModal()" [disabled]="isLoading">
        <span class="icon">📁</span> New Directory
      </button>
      <button class="btn btn-success" (click)="triggerFileUpload()" [disabled]="isLoading || isUploading">
        <span class="icon">📤</span> Upload File
      </button>
      <input #fileInput type="file" (change)="onFileSelected($event)" style="display: none">
    </div>
  </div>

  <div class="breadcrumb">
    <span class="breadcrumb-item" (click)="navigateToIndex(-1)">
      <span class="icon">🏠</span> Root
    </span>
    <ng-container *ngFor="let part of pathParts; let i = index">
      <span class="separator">/</span>
      <span class="breadcrumb-item" (click)="navigateToIndex(i)">{{ part }}</span>
    </ng-container>
  </div>

  <div class="alerts">
    <div class="alert alert-error" *ngIf="error">
      {{ error }}
      <button class="close-btn" (click)="error = null">×</button>
    </div>
    <div class="alert alert-success" *ngIf="successMessage">
      {{ successMessage }}
    </div>
    <div class="alert alert-info" *ngIf="isUploading">
      {{ uploadProgress }}
    </div>
  </div>

  <div class="files-table-wrapper">
    <div class="loading" *ngIf="isLoading">Loading...</div>

    <table class="files-table" *ngIf="!isLoading">
      <thead>
        <tr>
          <th>Name</th>
          <th>Size</th>
          <th>Last Modified</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="currentPath" (click)="goUp()" class="file-row clickable">
          <td><span class="file-icon">⬆️</span> ..</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
        </tr>
        <tr *ngFor="let item of files"
            class="file-row" [class.clickable]="item.isDirectory">
          <td (click)="openItem(item)">
            <span class="file-icon">{{ item.isDirectory ? '📁' : '📄' }}</span>
            {{ item.name }}
          </td>
          <td>{{ item.isDirectory ? '-' : formatSize(item.size) }}</td>
          <td>{{ item.lastModified | date:'yyyy-MM-dd HH:mm' }}</td>
          <td>
            <button *ngIf="!item.isDirectory"
                    class="btn btn-sm btn-download"
                    (click)="downloadFile(item); $event.stopPropagation()"
                    [disabled]="downloadingFile === item.path">
              {{ downloadingFile === item.path ? '⏳' : '⬇️' }} Download
            </button>
            <span *ngIf="item.isDirectory">-</span>
          </td>
        </tr>
        <tr *ngIf="files.length === 0 && !currentPath">
          <td colspan="4" class="empty-message">No files or directories found. Upload files to get started.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- New Directory Modal -->
  <div class="modal-overlay" *ngIf="showNewDirModal" (click)="closeNewDirModal()">
    <div class="modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Create New Directory</h3>
        <button class="close-btn" (click)="closeNewDirModal()">×</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Directory Name:</label>
          <input type="text" [(ngModel)]="newDirName" placeholder="Enter directory name"
                 (keydown.enter)="createDirectory()">
        </div>
        <div class="path-preview" *ngIf="newDirName">
          Path: {{ currentPath ? currentPath + '/' : '' }}{{ newDirName }}
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeNewDirModal()">Cancel</button>
        <button class="btn btn-primary" (click)="createDirectory()" [disabled]="!newDirName.trim()">Create</button>
      </div>
    </div>
  </div>
</div>

<a #downloadAnchor style="display:none"></a>

